import type { KeyboardEvent, MouseEvent } from 'react';

/**
 * A whole card as a button that opens its item: a click on it, or Enter /
 * Space while it holds focus. An event that reaches the card only through
 * React's tree — from a portaled child such as its open ⋮ menu — is not the
 * card's own and is ignored, so working the menu never also opens the card.
 */
export function cardOpenHandlers(label: string, open: () => void) {
  return {
    role: 'button',
    tabIndex: 0,
    'aria-label': label,
    onClick: (event: MouseEvent<HTMLElement>) => {
      if (event.target instanceof Node && event.currentTarget.contains(event.target)) open();
    },
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      if (event.target !== event.currentTarget) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
      }
    },
  };
}
